import CompanyHistoryTable from "/src/features/administration/company/components/CompanyTable/CompanyHistoryTable";
import { useLocation } from "react-router-dom";

function CompanyHistoryList() {
    const location = useLocation();
    var data = null;
    if (location.state != null) {
        data = location.state.data;
    }

    return <CompanyHistoryTable data={data} />;
}

export default CompanyHistoryList;
